export default __webpack_public_path__ + "static/media/taxi-driver.7eef9138.png";